
            const tabContentMap = {
                 "benefits-tab-productDes": {
                     content: ".replacement-product-view",
                 },
                 "specification-tab-productDes": {
                     content: ".specifications-container-productDescription",
                 },
                 "productDetails-tab-productDes": {
                     content: ".productDetails-container-productDes",
                 },
                 "returnWarranty-tab-productDes": {
                     content: ".returnAndWarranty-container-productDes",
                 },
             };

             const tabIds = Object.keys(tabContentMap);

             function handleTabClick(tabId) {
                 const currentTab = tabContentMap[tabId];

                 tabIds.forEach((id) => {
                     const tab = document.getElementById(id);
                     const tabContent = tabContentMap[id];
                     const isActive = id === tabId;

                     if (isActive) {
                         tab.classList.add("tab-productDes-active");
                         for (const key in tabContent) {
                             const contentSelector = tabContent[key];
                             document.querySelector(contentSelector).style.display = "block";
                         }
                     } else {
                         tab.classList.remove("tab-productDes-active");
                         for (const key in tabContent) {
                             const contentSelector = tabContent[key];
                             document.querySelector(contentSelector).style.display = "none";
                         }
                     }
                 });
             }

             tabIds.forEach((tabId) => {
                 const tab = document.getElementById(tabId);
                 tab.addEventListener("click", () => handleTabClick(tabId));
             });

             // Get all elements with class 'recharging'
             let rechargeDivs = document.querySelectorAll('.recharging');

             // Add mouseover and mouseout event listeners to each 'recharging' div
             rechargeDivs.forEach((div) => {
                 div.addEventListener('mouseover', function () {
                     // Set background color of hovered 'recharging' div image
                     let img = this.querySelector('img');
                     if (img) {
                         img.style.backgroundColor = '#87BD45'; // replace 'yourColor' with the color you want
                     }
                 });

                 div.addEventListener('mouseout', function () {
                     // Reset background color of 'recharging' div image
                     let img = this.querySelector('img');
                     if (img) {
                         img.style.backgroundColor = '#f8f8f8';
                     }
                 });
             });

             document.addEventListener("DOMContentLoaded", function () {
                 const arrowIcons = document.getElementsByClassName("arrow-iconn");
                 // Attach event listener to each arrow icon
                 Array.from(arrowIcons).forEach(function (arrowIcon) {
                     arrowIcon.addEventListener("click", function () {
                         // Toggle rotation class on the arrow icon
                         arrowIcon.classList.toggle("rotate-180");

                         // Traverse the DOM to find the corresponding table content
                         const table = arrowIcon.closest(".specification-table");
                         // Get all the rows except for the first row (header row)
                         const rows = Array.from(table.querySelectorAll("tr:not(:first-child)"));

                         // Toggle the hidden class on each row
                         rows.forEach(function (row) {
                             row.classList.toggle("hidden");
                         });
                     });
                 });
             });

    document.addEventListener('DOMContentLoaded', function () {
      var tabs = document.querySelectorAll('.model-slider-item');
      var containers = document.querySelectorAll('.model-slider-item-container');

      tabs.forEach(function (tab, index) {
          tab.addEventListener('click', function () {
              // Remove active class from all tabs
              tabs.forEach(function (item) {
                  item.classList.remove('active');
              });

              // Hide all containers
              containers.forEach(function (container) {
                  container.classList.remove('active-container');
              });

              // Add active class to clicked tab
              tab.classList.add('active');

              // Show the corresponding container
              containers[index].classList.add('active-container');
          });
      });
  });
